"use client";

import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

interface MemberListItemProps {
  name: string;
  roleLabel: string;
  role: string;
  secondaryText?: string | null;
  leading?: ReactNode;
  trailing?: ReactNode;
  compact?: boolean;
  onClick?: () => void;
}

export function roleBadgeClass(role: string): string {
  if (role === "owner") return "bg-m-primary/10 text-m-primary";
  if (role === "admin") return "bg-m-secondary/10 text-m-secondary";
  if (role === "guest") return "bg-m-text-hint/10 text-m-text-hint";
  return "bg-m-surface-light text-m-text-secondary";
}

export function MemberListItem({
  name,
  roleLabel,
  role,
  secondaryText,
  leading,
  trailing,
  compact = false,
  onClick,
}: MemberListItemProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        "flex items-start gap-3 rounded-xl border border-m-divider bg-m-surface",
        onClick ? "cursor-pointer transition-colors hover:bg-m-surface-light" : "",
        compact ? "px-3 py-2.5" : "px-3 py-3",
      )}
    >
      {leading ? <div className="shrink-0">{leading}</div> : null}
      <div className="min-w-0 flex-1">
        <div className="flex items-center gap-2">
          <span className="truncate text-sm font-medium text-m-text">{name}</span>
          <span
            className={cn(
              "shrink-0 rounded-md px-2 py-0.5 text-[11px] font-medium",
              roleBadgeClass(role),
            )}
          >
            {roleLabel}
          </span>
        </div>
        {secondaryText ? (
          <p className="mt-1 truncate text-xs text-m-text-secondary">{secondaryText}</p>
        ) : null}
      </div>
      {trailing ? <div className="shrink-0">{trailing}</div> : null}
    </div>
  );
}
